import { decodeContractError } from '../../utils.js';
import { buildRefundTx } from './buildRefundTx.js';
export async function refund(rpc, signer, params) {
    const tx = buildRefundTx(params);
    try {
        await rpc.ethCall(tx.to, tx.data, signer.address);
        return signer.sendTransaction(tx);
    }
    catch (error) {
        const errorName = decodeContractError(error);
        if (errorName)
            throw new Error(`Contract error: ${errorName}`);
        console.error('Error in refund:', error);
        throw error;
    }
}
